import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';

export interface ConfirmationData {
  header: string;
  message: string;
  type: 'btnCancel' | 'btnLanguage' | 'btnDeletePlace' | 'btnDeleteDay' | 'btnClose';
  cancelBtnLabel?: string;
  confirmBtnLabel?: string;
  responsiveModal?: boolean;
  disableConfirmBtn?: boolean;
}

@Injectable({
  providedIn: 'root',
})
export class ConfirmationDialogService {
  public isLoadingConfirm = new BehaviorSubject(false);
  private isDialogVisible: boolean = false;
  public confirmationDataSubject: BehaviorSubject<ConfirmationData | null> =
    new BehaviorSubject<ConfirmationData | null>(null);
  public confirmationData$: Observable<ConfirmationData | null> =
    this.confirmationDataSubject.asObservable();
  private acceptCallback: (() => void) | null = null;
  private rejectCallback: (() => void) | null = null;
  private type: string;

  isConfirmationDialogVisible(): boolean {
    return this.isDialogVisible;
  }

  setConfirmationData(
    data: ConfirmationData,
    acceptCallback: (() => void) | null = null,
    rejectCallback: (() => void) | null = null,
    type?: string
  ): void {
    this.confirmationDataSubject.next(data);
    this.acceptCallback = acceptCallback;
    this.rejectCallback = rejectCallback;
    this.type = type!;
  }

  clearConfirmationData(): void {
    this.confirmationDataSubject.next(null);
    this.acceptCallback = null;
    this.rejectCallback = null;
  }

  executeAcceptCallback(): void {
    if (this.acceptCallback) {
      this.acceptCallback();
    }
    if (this.type !== 'loading') {
      this.clearConfirmationData();
    }
  }

  executeRejectCallback(): void {
    if (this.rejectCallback) {
      this.rejectCallback();
    }
    this.clearConfirmationData();
  }
}
